/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable import/no-duplicates */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-function */
import { ReactNode, CSSProperties, useState, useRef, useEffect } from 'react'
import './TopNavigation.css'
import twsLogoFull from '../../assets/V360_WeatherBlack.svg'
import twsLogoSmall from '../../assets/TruWeatherWhiteSmall.svg'
// import grandSkyLogo from '../../assets/grandSky-icon.svg'
import grandSkyLogo from '../../assets/grandsky-logo.svg'
import grandSkyLogoSml from '../../assets/grandSky-icon.svg'
import aeroxLogoSml from '../../assets/aeroxLogoSmall.png'
import AeroXLogoBig from '../../assets/AeroXLogoBig.png'
// import SearchInput from './SearchInput/SearchInput'
import collapseicon from '../../assets/collapse.svg'
import LocationIndicator from './LocationIndicator/LocationIndicator'
import AlertIndicator from './AlertIndicator/AlertIndicator'
import ProfileMenu from '../ProfileMenu/ProfileMenu'
import { useDispatch, useSelector } from 'react-redux'
import { expand, collapse } from '../SideNavigation/SideNavigationSlice'
import { Link } from 'react-router-dom'
import AlertSetting from '../../Components/Alerting/AlertSetting/AlertSetting'
import { RootState } from '../../store'
import { ApiLoader } from '../../Components/Spinner/ApiLoader'
import { AEROX_ORG_ID, GRANDSKY_ORG_ID } from '../../constants/OrganizationIds'
import FeatureGate from '../../Components/FeatureGate/FeatureGate'
import { MENU_ID } from '../../environment/featureFlags'

type Props = {
  children?: ReactNode
  className?: string
  style?: CSSProperties
  burgerHandler: (menuExpanded: boolean) => void
}

export default function TopNavigation(props: Props) {
  // const [numberOfAlerts, setNumberOfAlerts] = useState(0)
  const [smallLogo, setSmallLogo] = useState(false)
  const burgerRef = useRef<SVGSVGElement>(null)
  const dispatch = useDispatch()
  const [dismissedAlerts] = useState<number>(0)
  const apiLoader = useSelector((state: RootState) => state.apiLoading)
 
  const settingAlertNotification = useSelector(
    (state: RootState) => state.alert.setAlertingNotification
  )
  const showAlertCreate = useSelector(
    (state: RootState) => state.alert.showAlertSETTINGCreate
  )
  const removeAlert = useSelector((state: RootState) => state.alert.removeAlert)

  const alertSettingedit = useSelector(
    (state: RootState) => state.alert.showAlertSETTINGEdit
  )
  const selectedP = useSelector((state: RootState) => state.alert.setProperties)

  const expandedState = useSelector(
    (state: RootState) => state.sideNav.expanded
  )
  const [menuExpanded, setMenuExpanded] = useState(!expandedState)
  const [numberOfAlerts, setNumberOfAlerts] = useState<number>(0)
  useEffect(() => {
    var eventList = []
    if( settingAlertNotification.length == 2 && typeof settingAlertNotification[1] !== 'object' ) eventList = settingAlertNotification[0]
    else eventList = settingAlertNotification
    if (settingAlertNotification[0]) {
      setNumberOfAlerts(settingAlertNotification[0].length)
    } else {
      setNumberOfAlerts(0)
    }
  }, [settingAlertNotification, removeAlert])
  // Sync local state with Redux state
  useEffect(() => {
    setMenuExpanded(expandedState)

    const handleResize = () => {
      const windowWidth = window.innerWidth

      if (windowWidth <= 1000) {
        setSmallLogo(true)
      } else {
        setSmallLogo(false)
      }
    }

    // Add the event listener when the component mounts
    window.addEventListener('resize', handleResize)

    // Remove the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [expandedState])
  const reseller = useSelector((state: RootState) => state.user.reseller)

  const expandMenu = () => {
    const burgerElement = burgerRef.current
    if (menuExpanded) {
      burgerElement?.classList?.remove('active')
      burgerElement?.classList?.add('inactive')
      dispatch(collapse())
    } else {
      burgerElement?.classList?.remove('inactive')
      burgerElement?.classList?.add('active')
      dispatch(expand())
    }
    props.burgerHandler(!menuExpanded)
  }

  const burger = (
    <div className='relative w-12 h-12 flex items-center justify-center rounded-md hover:bg-[#1d293d]'>
      {/* Render Burger Icon when Menu is Collapsed */}
      {!menuExpanded && (
        <svg
          ref={burgerRef}
          onClick={expandMenu}
          className="ham hamRotate ham1"
          viewBox="0 0 100 100"
          width="48"
          fill="#000"
          style={{ filter: 'brightness(0) invert(1)', cursor: 'pointer' }}
        >
          <path
            fill="#000"
            className="line top"
            d="m 30,33 h 40 c 0,0 9.044436,-0.654587 9.044436,-8.508902 0,-7.854315 -8.024349,-11.958003 -14.89975,-10.85914 -6.875401,1.098863 -13.637059,4.171617 -13.637059,16.368042 v 40"
          />
          <path fill="#000" className="line middle" d="m 30,50 h 40" />
          <path
            fill="#000"
            className="line bottom"
            d="m 30,67 h 40 c 12.796276,0 15.357889,-11.717785 15.357889,-26.851538 0,-15.133752 -4.786586,-27.274118 -16.667516,-27.274118 -11.88093,0 -18.499247,6.994427 -18.435284,17.125656 l 0.252538,40"
          />
        </svg>
      )}

      {/* Render Collapse Icon when Menu is Expanded */}
      {menuExpanded && (
        <img
          src={collapseicon}
          alt="Collapse Icon"
          onClick={expandMenu}
          style={{
            width: '20px',
            height: '20px',
            filter: 'brightness(0) invert(1)',
            cursor: 'pointer'
          }}
        />
      )}
    </div>

  )
  let logo: ReactNode

  if (!menuExpanded) {
    if (reseller?.reseller == GRANDSKY_ORG_ID) {
      logo = (
        <Link to="/map">
          <div
            style={{
              width: '55px',
              height: '42px',
              display: 'inline-block',
              backgroundColor: 'black',
            }}
          >
            <img
              style={{ width: '55px', height: '42px', margin: '12px 0 0 2px' }}
              src={grandSkyLogoSml}
              alt="logo"
            />
          </div>
        </Link>
      )
    } else if (reseller?.reseller === AEROX_ORG_ID){
      logo = (
        <Link to="/map">
          <div
            style={{
              width: '55px',
              height: '42px',
              display: 'inline-block',
              backgroundColor: 'black',
            }}
          >
            <img
              style={{ width: '55px', height: '42px', margin: '12px 0 0 2px' }}
              src={aeroxLogoSml}
              alt="logo"
            />
          </div>
        </Link>
      )
    }else {
      logo = (
        <Link to="/map">
          <div
            style={{ width: '55px', height: '42px', display: 'inline-block' }}
          >
            <img
              style={{ height: '42px', width: '55px', margin: '12px 0 0 2px' }}
              src={twsLogoSmall}
              alt="logo"
            />
          </div>
        </Link>
      )
    }
  } else {
    if (reseller?.reseller == GRANDSKY_ORG_ID) {
      logo = (
        <Link to="/map">
          <div
            style={{
              width: smallLogo ? '55px' : '260px',
              height: '42px',
              display: 'inline-block',
              backgroundColor: 'black',
            }}
          >
            <img
              style={{
                width: smallLogo ? '55px' : '260px',
                height: '42px',
                margin: '12px 0 0 2px',
              }}
              src={smallLogo ? grandSkyLogoSml : grandSkyLogo}
              alt="logo"
            />
          </div>
        </Link>
      )
    } else if (reseller?.reseller == AEROX_ORG_ID) {
      logo = (
        <Link to="/map">
          <div
            style={{
              width: smallLogo ? '55px' : '200px',
              height: '42px',
              display: 'inline-block',
              backgroundColor: 'black',
            }}
          >
            <img
              style={{
                width: smallLogo ? '55px' : '200px',
                height: '42px',
                margin: '12px 0 0 2px',
              }}
              src={smallLogo ? aeroxLogoSml : AeroXLogoBig}
              alt="
              logo"
            />
          </div>
        </Link>
      )
    } else {
      logo = (
        <Link to="/map">
          <div
            style={{
              width: smallLogo ? '55px' : '260px',
              height: '42px',
              display: 'inline-block',
            }}
          >
            <img
              style={{ height: '42px', margin: '12px 0 0 2px', width: '230px' }}
              src={smallLogo ? twsLogoSmall : twsLogoFull}
              alt="logo"
            />
          </div>
        </Link>
      )
    }
  }
  return (
    <>
      <div className="flex basis-16 grow-0 shrink-0 w-full bg-navigationBg overflow-y-hidden z-[9999999] min-w-min px-2">
        {logo}
        <div className="w-full flex justify-between ml-0 overflow-y-hidden ">
          <div className="inline-block w-14 mt-2" title="Expand/Collapse Menu">
            {/* {burger} */}
          </div>
          {/*<SearchInput></SearchInput>*/}
          <LocationIndicator></LocationIndicator>
          {apiLoader ? <ApiLoader /> : null}
          <div className="flex gap-2 items-center">
            {/*
              The bell is a second, independent entry point into alerting -
              AlertIndicator dispatches selectedItems(ALERTS_MENU) directly - so
              gating the ProfileMenu link alone would leave it working.
            */}
            <FeatureGate flag={MENU_ID.ALERTING_MONITORS} requireRegion>
              <AlertIndicator
                // onDismissAlert={handleDismissAlert}
                alertnumber={numberOfAlerts}
                dismissedAlerts={dismissedAlerts}
                alerts={settingAlertNotification}
              />
            </FeatureGate>
            <ProfileMenu></ProfileMenu>
          </div>
        </div>
      </div>
      {/*
        Both AlertSetting mounts are driven by redux flags that a restored saved
        view can set (RestoreSelection), a path that touches neither the bell nor
        the ProfileMenu link - so this panel needs its own gate.
      */}
      <FeatureGate flag={MENU_ID.ALERTING_MONITORS} requireRegion>
        <div className="ml-40">
          {alertSettingedit && (
            <AlertSetting properties={selectedP} key="create-alert-box" />
          )}
          {showAlertCreate ? (
            <AlertSetting isEditing={undefined} key="edit-alert-box" />
          ) : null}
        </div>
      </FeatureGate>
    </>
  )
}
